import { Alert, Box, HStack, Text, VStack } from "native-base";
import colors from "theme/colors";

const styles = {
  box: {
    backgroundColor: colors.tooltip.blueBody,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: colors.tooltip.blueBorder,
    padding: 16,
    marginBottom: 16,
  },
  infoIconContainer: { marginRight: 16, color: colors.secondary.orchid },
};

function getTextContentBasedonType(textContent, props = {}) {
  if (Array.isArray(textContent)) {
    return textContent.map((c, i) => (
      <Text fontSize="xs" key={c} {...props}>
        {i + 1}. {c}
      </Text>
    ));
  }

  return (
    <Text fontSize="xs" {...props}>
      {textContent}
    </Text>
  );
}

const CustomToolTip = ({ title, textContent, containerStyle }) => {
  return (
    <Alert status="info" testID="customTooltip" style={[styles.box, containerStyle]}>
      <VStack w="100%" justifyContent="flex-start">
        <HStack>
          <Alert.Icon size="16px" style={styles.infoIconContainer} />
          <VStack flex={1} display="flex">
            <Text fontSize="xs" fontWeight="medium">
              {title}
            </Text>
            <Box pr="30px" mr="10px" flexWrap="wrap">
              {getTextContentBasedonType(textContent, { flexWrap: "wrap" })}
            </Box>
          </VStack>
        </HStack>
      </VStack>
    </Alert>
  );
};

export default CustomToolTip;
